// ui/pages/CapacitacionesListPage.jsx  (compone hook + componentes; aquí viven Swal, history, Auth)
import React from 'react';
import { useHistory } from 'react-router-dom';
import CardContainer from '../../../../../components/card/card-container.jsx';
import ListToolbar, { BtnNuevo, BtnSecundario, BtnEliminar } from '../../../../../nuup/componentes/Toolbar/ListToolbar.jsx';
import SelectCiclo from '../../../../../components/select/select-ciclo.jsx';
import SearchColumn from '../../../../../components/search/search-column.jsx';
import LinkDownloadExcel from '../../../../../components/link/link-download-excel.jsx';
import { useAuth } from '../../../../../components/content/auth.jsx';
import { useCapacitaciones } from '../../application/useCapacitaciones';
import { canDelete } from '../../../shared/domain/permissions';
import { confirmDelete, showError, showSuccess } from '../../../shared/ui/feedback';
import CapacitacionesTable from '../components/CapacitacionesTable.jsx';
import CapacitacionesExport from '../export/capacitacionesExport';
import { CAPACITACIONES_PATH } from '../../../constants';

const detailPath = item => `${CAPACITACIONES_PATH}/detail/${item.uuid}`;
const editPath = item => `${CAPACITACIONES_PATH}/edit/${item.uuid}`;

const searchColumns = [
  { value: 0, target: '', label: 'TODO' },
  { value: 1, target: 'fecha', label: 'FECHA' },
  { value: 2, target: 'nombre_capacitacion', label: 'NOMBRE' },
  { value: 3, target: 'municipio_nombre', label: 'MUNICIPIO' },
  { value: 4, target: 'localidad_nombre', label: 'LOCALIDAD' },
  { value: 5, target: 'responsable', label: 'RESPONSABLE' },
  { value: 6, target: 'actividad_nombre', label: 'ACTIVIDAD' },
];

const CapacitacionesListPage = () => {
  const auth = useAuth();
  const history = useHistory();
  const user = auth.user;
  const { data, status, error, setIdCiclo, remove } = useCapacitaciones();
  const [ciclo, setCiclo] = React.useState(null);
  const [selectedUuid, setSelectedUuid] = React.useState(null);
  // Adaptador para el SearchColumn legacy: guarda su propia copia y solo re-filtra al escribir o cuando
  // cambia `clearSearchItem`. Pasando `data` ahí, cada carga del hook reinicia la búsqueda y re-emite la lista completa.
  const [visibleRows, setVisibleRows] = React.useState([]);

  // La selección se DERIVA del uuid: si la fila desaparece (recarga, otro ciclo, filtro) deja de haber selección.
  const selected = React.useMemo(() => visibleRows.find(row => row.uuid === selectedUuid) || null, [visibleRows, selectedUuid]);

  React.useEffect(() => {
    if (status === 'error') showError(error);
  }, [status, error]);

  const handleCiclo = React.useCallback(
    evt => {
      setCiclo(evt.target);
      setIdCiclo(evt.target.id);
    },
    [setIdCiclo]
  );

  const handleDelete = async () => {
    if (!selected) return;
    if (!(await confirmDelete({ title: 'Eliminar capacitación', text: `"${selected.nombre_capacitacion}" desaparecerá del listado.` })))
      return;
    try {
      await remove(selected.uuid);
      setSelectedUuid(null);
      showSuccess('Capacitación eliminada');
    } catch (e) {
      showError(e);
    }
  };

  return (
    <div>
      <div className="row justify-content-between">
        <SelectCiclo setFilter={handleCiclo} />
        <div className="col-8 d-flex justify-content-end">
          {/* Siempre visible, como en el resto de listados de la app y en Figma. */}
          <div style={{ alignSelf: 'center', marginBottom: 12, marginLeft: 12 }}>
            <LinkDownloadExcel handleExport={() => CapacitacionesExport(visibleRows, ciclo ? ciclo.nombre : '')} />
          </div>
        </div>
      </div>

      <CardContainer height={'100%'}>
        <ListToolbar left={<SearchColumn data={data} columns={searchColumns} setDataFilter={setVisibleRows} clearSearchItem={data} />}>
          <BtnNuevo to={{ pathname: `${CAPACITACIONES_PATH}/create` }}>Nueva Capacitación</BtnNuevo>
          <BtnSecundario disabled={!selected} onClick={() => history.push(editPath(selected))}>
            Editar
          </BtnSecundario>
          <BtnEliminar show={canDelete(user)} disabled={!selected} onClick={handleDelete} />
        </ListToolbar>
        <CapacitacionesTable
          data={visibleRows}
          blocking={status === 'loading' || status === 'idle'}
          selectedUuid={selectedUuid}
          onSelect={setSelectedUuid}
          detailPath={detailPath}
        />
      </CardContainer>
    </div>
  );
};

export default CapacitacionesListPage;
